import { call, fork, put, takeEvery } from 'redux-saga/effects';

import { ClarisApiError } from '../domain/error';

import {
  DeleteSettingsIPAction,
  PostSettingsIPAction,
  PutSettingsIPAction,
  SettingsIPActionCreators,
  SettingsIPActionTypes,
} from '../redux/server/settingIpSetting';
import { Api, buildConfig } from '../utils/api';
import { handleErrorSaga } from './errorSaga';

export function* postSettingsIPSaga(api: Api, action: PostSettingsIPAction) {
  try {
    const { params } = action.payload;

    yield put(SettingsIPActionCreators.postSettingsIPRequestAction());

    yield call(api.post, `/settings/ipRestriction`, params, buildConfig());

    yield put(SettingsIPActionCreators.postSettingsIPSuccessAction());
  } catch (error: unknown) {
    yield put(
      SettingsIPActionCreators.postSettingsIPFailureAction(
        error as ClarisApiError
      )
    );
    yield fork(handleErrorSaga, error);
  }
}

export function* putSettingsIPSaga(api: Api, action: PutSettingsIPAction) {
  try {
    const { params } = action.payload;

    yield put(SettingsIPActionCreators.putSettingsIPRequestAction());

    yield call(
      api.patch,
      `/settings/ipRestriction/${params.groupIpId}`,
      params,
      buildConfig()
    );

    yield put(SettingsIPActionCreators.putSettingsIPSuccessAction());
  } catch (error: unknown) {
    yield put(
      SettingsIPActionCreators.putSettingsIPFailureAction(
        error as ClarisApiError
      )
    );
    yield fork(handleErrorSaga, error);
  }
}

export function* deleteSettingsIPSaga(
  api: Api,
  action: DeleteSettingsIPAction
) {
  try {
    const { groupIpId } = action.payload;

    yield put(SettingsIPActionCreators.deleteSettingsIPRequestAction());

    yield call(
      api.delete,
      `/settings/ipRestriction/${groupIpId}`,
      buildConfig()
    );

    yield put(SettingsIPActionCreators.deleteSettingsIPSuccessAction());
  } catch (error: unknown) {
    yield put(
      SettingsIPActionCreators.deleteSettingsIPFailureAction(
        error as ClarisApiError
      )
    );
    yield fork(handleErrorSaga, error);
  }
}

function* handlePostSettingsIPSaga(api: Api) {
  yield takeEvery(
    SettingsIPActionTypes.POST_SETTINGS_IP,
    postSettingsIPSaga,
    api
  );
}

function* handlePutSettingsIPSaga(api: Api) {
  yield takeEvery(
    SettingsIPActionTypes.PUT_SETTINGS_IP,
    putSettingsIPSaga,
    api
  );
}

function* handleDeleteSettingsIPSaga(api: Api) {
  yield takeEvery(
    SettingsIPActionTypes.DELETE_SETTINGS_IP,
    deleteSettingsIPSaga,
    api
  );
}

export function* settingsIPSagas(context: { api: Api }) {
  yield fork(handlePostSettingsIPSaga, context.api);
  yield fork(handlePutSettingsIPSaga, context.api);
  yield fork(handleDeleteSettingsIPSaga, context.api);
}
